"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertProvider = exports.AlertContext = void 0;
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("./Alert"));
const alertInitialState = {
    buttons: [],
    visible: false,
    notClosableByOutsidePress: false,
    hideBackButton: false,
    message: '',
    title: '',
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'set_alert_buttons':
            return {
                ...state,
                buttons: action.payload,
            };
        case 'set_alert_not_closable_by_outside_press':
            return {
                ...state,
                notClosableByOutsidePress: action.payload,
            };
        case 'set_alert_hide_back_button':
            return {
                ...state,
                hideBackButton: action.payload,
            };
        case 'set_alert_severity':
            return {
                ...state,
                severity: action.payload,
            };
        case 'set_alert_message':
            return {
                ...state,
                message: action.payload,
            };
        case 'set_alert_title':
            return {
                ...state,
                title: action.payload,
            };
        case 'set_alert_visible':
            return {
                ...state,
                visible: action.payload,
            };
    }
};
exports.AlertContext = react_1.createContext({
    state: alertInitialState,
    dispatch: () => null,
});
const AlertProvider = ({ children }) => {
    const [state, dispatch] = react_1.useReducer(reducer, alertInitialState);
    return (react_1.default.createElement(exports.AlertContext.Provider, { value: { state, dispatch } },
        react_1.default.createElement(Alert_1.default, { hideBackButton: state.hideBackButton, message: state.message, notClosableByOutsidePress: state.notClosableByOutsidePress, title: state.title, severity: state.severity, visible: state.visible, buttons: state.buttons, onRequestClose: () => dispatch({ type: 'set_alert_visible', payload: false }) }),
        children));
};
exports.AlertProvider = AlertProvider;
